var map = {
	"./Copyright-office.webp": 3564,
	"./ICV.webp": 5002,
	"./LOGO.png": 1581,
	"./Ministry-of-corporate.webp": 8951,
	"./Mrs-Pradullabai-Deshmukh.png": 3308,
	"./SANDEEP.webp": 2828,
	"./Start-up.webp": 878,
	"./VIRJAA.webp": 3575,
	"./WhatsApp Image 2025-11-07 at 7.11.53 PM (2).jpeg": 404,
	"./WhatsApp Image 2025-11-07 at 7.11.54 PM (1).jpeg": 8136,
	"./WhatsApp Image 2025-11-07 at 7.11.54 PM (2).jpeg": 7015,
	"./WhatsApp Image 2025-11-07 at 7.11.54 PM (3).jpeg": 4922,
	"./WhatsApp Image 2025-11-07 at 7.11.54 PM.jpeg": 7230,
	"./WhatsApp Image 2025-11-07 at 7.11.55 PM (1).jpeg": 1113,
	"./WhatsApp Image 2025-11-07 at 7.11.55 PM (2).jpeg": 4510,
	"./WhatsApp Image 2025-11-07 at 7.11.55 PM.jpeg": 8819,
	"./WhatsApp Image 2025-11-07 at 7.11.56 PM (1).jpeg": 1254,
	"./WhatsApp Image 2025-11-07 at 7.11.56 PM (2).jpeg": 4529,
	"./WhatsApp Image 2025-11-07 at 7.11.56 PM.jpeg": 588,
	"./WhatsApp Image 2025-11-07 at 7.11.57 PM (1).jpeg": 7407,
	"./WhatsApp Image 2025-11-07 at 7.11.57 PM (2).jpeg": 2640,
	"./WhatsApp Image 2025-11-07 at 7.11.57 PM.jpeg": 4009,
	"./WhatsApp Image 2025-11-07 at 7.11.58 PM (1).jpeg": 8788,
	"./WhatsApp Image 2025-11-07 at 7.11.58 PM (2).jpeg": 6947,
	"./WhatsApp Image 2025-11-07 at 7.11.58 PM.jpeg": 7978,
	"./WhatsApp Image 2025-11-07 at 7.11.59 PM (1).jpeg": 9141,
	"./WhatsApp Image 2025-11-07 at 7.11.59 PM (2).jpeg": 1594,
	"./WhatsApp Image 2025-11-07 at 7.11.59 PM.jpeg": 447,
	"./WhatsApp Image 2025-11-07 at 7.12.00 PM (1).jpeg": 2266,
	"./WhatsApp Image 2025-11-07 at 7.12.00 PM (2).jpeg": 9445,
	"./WhatsApp Image 2025-11-07 at 7.12.00 PM.jpeg": 1280,
	"./WhatsApp Image 2025-11-07 at 7.12.01 PM (1).jpeg": 9651,
	"./WhatsApp Image 2025-11-07 at 7.12.01 PM (2).jpeg": 3652,
	"./WhatsApp Image 2025-11-07 at 7.12.01 PM (3).jpeg": 6369,
	"./WhatsApp Image 2025-11-07 at 7.12.01 PM.jpeg": 5725,
	"./WhatsApp Image 2025-11-07 at 7.12.02 PM.jpeg": 8290,
	"./WhatsApp-Image-2024-02-03-at-10.35.13_adf82b41.jpg": 979,
	"./WhatsApp-Image-2024-02-03-at-10.40.42_77be0a82.jpg": 9075,
	"./WhatsApp-Image-2024-05-16-at-11.28.05_9b01981f-1.jpg": 4332,
	"./WhatsApp-Image-2024-05-16-at-11.29.03_d3774aac.jpg": 6015,
	"./WhatsApp-Image-2024-05-16-at-11.32.03_04a3f6ae.jpg": 385,
	"./hirnaya.webp": 8828,
	"./india.webp": 5751,
	"./msme.webp": 706,
	"./women.jpg": 1628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5981;